import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRouteAdminModule = ({ children }) => {
  // Check if admin is authenticated
  const isAdminAuthenticated = () => {
    const adminToken = localStorage.getItem('adminToken');
    const adminData = localStorage.getItem('adminData');
    
    // You can add more validation here like token expiry check
    return adminToken && adminData;
  };

  // If not authenticated, redirect to admin login
  if (!isAdminAuthenticated()) {
    return <Navigate to="/admin/login" replace />;
  }

  // If authenticated, render the protected component
  return children;
};

export default ProtectedRouteAdminModule;